import React, { Component } from "react";
import NewsList_BannerTitle from "../layouts/news/NewsList_BannerTitle";
import NewsList_SideBar from "../layouts/news/NewsList_SideBar";
import NewsList_Content from "../layouts/news/NewsList_Content";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
// import { firestore, firestoreObject } from "../../helpers/Firebase";
import { TimestampToDate } from "src/helpers/functions";

import data from "../../data/news.json";
import media from "../../data/mediaPartners.json";

class NewsList extends Component {
  constructor(props) {
    super(props);

    const { location } = this.props;

    let type = "novosti";
    if (location.pathname.includes("/news-list-media")) type = "mediji";
    if (location.pathname.includes("/blog-list")) type = "blog";

    let allNews = data.news
      .sort((a, b) => {
        const aDate = new Date(a.releaseDate);
        const bDate = new Date(b.releaseDate);

        return bDate.getTime() - aDate.getTime();
      })
      .map((x) => {
        const date = new Date(x.releaseDate);

        return {
          ...x,
          id: x.ID,
          srcimg: x.headerImage,
          aritcles: "hentry data-effect",
          classnames:
            "post-media data-effect-item has-effect-icon offset-v-25 offset-h-24clerafix",
          date: date.toLocaleDateString("hr-HR"),
          day: date.getDate(),
          month: date.getMonth() + 1,
        };
      });
    let mediaPartners = media.mediaPartners.map((x) => {
      return { ...x };
    });

    const newsList = allNews.filter((y) => {
      if (location.pathname.includes("/news-list-media"))
        return y.categories.includes("Mediji");
      if (location.pathname.includes("/blog-list"))
        return y.categories.includes("Blog");
      return !y.categories.includes("Blog");
    });

    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "Novosti",
        },
      ],
      banners: [
        {
          id: 1,
          links: "",
          titlelink: "",
          border: "",
          name: "Novosti",
          heading: "Novosti",
        },
      ],
      categories: data.categories,
      newsList,
      allNews,
      type,
      mediaPartners,
    };
  }

  // FirebaseRemoved
  // componentDidMount() {
  //   this.loadNews();
  // }

  // async loadNews() {
  //   firestore
  //     .collection("Web/Corporate/DataBase/News/DataBase")
  //     .where("releaseDate", "<=", firestoreObject.Timestamp.now())
  //     .orderBy("releaseDate", "desc")
  //     .get()
  //     .then((querySnapshot) => {
  //       const newsList = [];
  //       console.log(querySnapshot);
  //       querySnapshot.forEach((doc) => {
  //         const data = doc.data();
  //         newsList.push({
  //           ...data,
  //           id: doc.id,
  //           srcimg: data.headerImage,
  //           aritcles: "hentry data-effect",
  //           classnames:
  //             "post-media data-effect-item has-effect-icon offset-v-25 offset-h-24clerafix",
  //           title: data.title,
  //           date: TimestampToDate(data.releaseDate),
  //           day: new Date(data.releaseDate * 1000).getDate(),
  //           month: TimestampToDate(data.releaseDate, {
  //             month: "short",
  //           }),
  //           author: data.author,
  //           comments: "3",
  //           shortContent: data.shortContent,
  //         });
  //       });

  //       this.setState({ newsList, loading: false });
  //     })
  //     .catch((e) => console.log(e));
  // }

  render() {
    const { newsList, loading, type, allNews, mediaPartners } = this.state;

    return (
      <div className="header-fixed sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <NewsList_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={60}
                  data-mobile={60}
                  data-smobile={60}
                />

                {loading ? (
                  <div className="loading" />
                ) : (
                  <NewsList_Content newsList={newsList} type={type} />
                )}

                <NewsList_SideBar
                  mediaPartners={mediaPartners}
                  newsList={allNews
                    .filter((x) => !x.categories.includes("Blog"))
                    .slice(0, 3)}
                />
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={80}
                  data-mobile={60}
                  data-smobile={60}
                />
              </div>
            </div>
            <Footer />
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default NewsList;
